import React from 'react'
import landsalekolkataairport from "../images/land sale kolkata airport update.jpg";
import owntheland from "../images/own the land novesta group.jpg";
import landivestment from "../images/land invest kolkata airport.jpg";

import nearkolkataairportplot from "../images/near kolkata airport.jpg";
import unicornaerocityplot from "../images/novesta group dream project.jpg"
import nearkolkataairport from "../images/unicorn aerocity plot.jpg";


function Gallery() {
  return (
    <div>
         <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-4 mt-2">
              <div className='radiusnew'>
                <img src={landsalekolkataairport} className="card-img-top" alt="landsalekolkataairport" />
              </div>
            </div>
            <div className="col-md-4 mt-2">
              <div className='radiusnew'>
                <img src={owntheland} className="card-img-top" alt="plotarea_uniocornaerocity" />
              </div>
            </div>

             <div className="col-md-4 mt-2">
              <div className='radiusnew'>
                <img src={landivestment} className="card-img-top" alt="landivestment Kolkata aireport area runway" />
              </div>
            </div>

            <div className="col-md-4 mt-2">
              <div className='radiusnew'>
                <img src={nearkolkataairportplot} className="card-img-top" alt="nearkolkataairportplot" />
              </div>
            </div>
            <div className="col-md-4 mt-2">
              <div className='radiusnew'>
                <img src={unicornaerocityplot} className="card-img-top" alt="landivestment Kolkata aireport area runway_unicornaerocityplot" />
              </div>
            </div>
            <div className="col-md-4 mt-2">
              <div className='radiusnew'>
                <img src={nearkolkataairport} className="card-img-top" alt="nearkolkataairport" />
              </div>
            </div>

            
          </div>
        </div>
      </div>
      <br/>
    </div>
  )
}

export default Gallery